"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Store = void 0;
var _1 = require(".");
/**
 * Base store class for others to extend.
 */
var Store = /** @class */ (function () {
    /**
     * Constructor.
     */
    function Store(opts) {
        this.rootStore = opts.rootStore;
    }
    /**
     * Creates a collection that gets the root store passed in.
     */
    Store.prototype.collection = function (opts) {
        return (0, _1.collection)(__assign({ rootStore: this.rootStore, create: function (attributes, options) {
                return new opts.model(attributes, __assign({ stripUndefined: true, parse: true }, options));
            }, update: function (existing, input, options) {
                return existing.set(input, __assign({ stripUndefined: true, parse: true }, options));
            } }, opts));
    };
    return Store;
}());
exports.Store = Store;
//# sourceMappingURL=store.js.map